import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[stickyHost]' // eslint-disable-line @angular-eslint/directive-selector
})
export class StickyHostDirective {
  constructor(
    public viewContainerRef: ViewContainerRef
  ) {
  }
}
